<div class="ui-demo bg-color--bg">
  <div class="title-block">
    <h1 class="title--main">UI DEMO PAGE</h1>
  </div>


  
  <h2 class="title--sub">DatePicker {{state.time0}} {{state.time1}}</h2>
  <p style="margin-bottom:30px">時間 {{state.ttt}}</p>
  <date-picker class="datePicker"  v-model:value="state.ttt" type="date" 
  range prefix-class="xmx" ></date-picker>
  <DatePickerLocal @changeDatePicker="changeDatePicker" :value="state.ttt" style="width: 280px;"></DatePickerLocal>



  <h2 class="title--sub">multiSelect </h2>
  <p style="margin-bottom:30px">選擇結果 {{state.multiSelectVal}} </p>
  <multiSelect  v-model:selected="state.multiSelectVal"  style="width: 380px;" hasAll="All Type"
    :isError="false" :isDisable="false"></multiSelect>
  
  
  
  <h2 class="title--sub">Loading</h2>
  <Button @onClick="state.isLoading = !state.isLoading" class="btn-inline" type="border" colors="main"
    text="open"></Button>
  <Loading :isOpen="state.isLoading"></Loading>

  <h2 class="title--sub">Pagination</h2>
  <p style="margin-bottom:30px">page meta : {{state.meta}} , 限制出現的頁數 : {{state.range}} , flex的位置 : start</p>
  <Pagination :input="true" :totalPage="state.meta.total_page" position="start" :nowPage="state.meta.current" :range="range"
    @changePage="changePage"></Pagination>


  <h2 class="title--sub">Flash Msg</h2>
  <p>isOpenFlashMsg: {{state.isOpenFlashMsg}}</p>
  <Button @onClick="openFlashMsg" class="btn-inline" type="border" colors="main" text="open"></Button>
  <FlashMsg text="AAA" v-model:isOpen="state.isOpenFlashMsg"></FlashMsg>

  <h2 class="title--sub">Timer</h2>

  <Button @onClick="state.isStart = true" class="btn-inline" type="border" colors="main" text="START"></Button>
  <Timer v-model:isStart="state.isStart" :time="state.time" @finish="finshTimer"></Timer>



  <h2 class="title--sub">Table</h2>
  <p style="margin-bottom:30px">Table data : </p>
  <Table :disableCheck="state.disList" @tableSort="tableSort" @onCheckAll="onCheckAll" @showCTAndRow="showCTAndRow"
    @onCheckEach="onCheckEach" @goTableLink="goTableLink" :checkBox="true" :dropdown="true">
    <template #second="{index, data}">
      <TableInfo @applyToCalibration="applyCalibration" :data="data.dataInfo" :columns="state.columns">
      </TableInfo>
    </template>
    <template #boxth="{index}">
      <span>{{index}} you can also custom th</span>
    </template>
    <template #box="{index}">
      <span>{{index}} custom render slot</span>
    </template>
    <template #contextMenu="{position}">
      <CTmenu @selectContextMenu="selectContextMenu" :position="position"></CTmenu>
    </template>
    <template #empty="{text}">
      <div class="Nodata">{{text}}</div>
    </template>
    <!-- <template #box="{index}">
      <span>{{index}} custom render slot</span>
    </template> -->

  </Table>

  <h2 class="title--sub">CollapseMultiSelect 複合式版型</h2>
  <p style="margin-bottom:5px">tempData data : 選擇modal list 的暫存陣列 </p>
  <p style="margin-bottom:30px">dataToMulti data : 綁定進去複合式版型的list </p>
  <CollapseMultiSelect @showModal="showModal" :data="state.dataToMulti"></CollapseMultiSelect>

  <div v-if="state.isShowModal">
    <div class="tempModalData">
      <div v-for="(item,index) in data" @click="chooseItem(item,index)" class="tempModalData_each">{{item.name}}</div>
    </div>
    <div class="tempModalData">
      <Button type="both" @onClick="modalCancel" text="取消" class="btn-inline" colors="main" theme="1"></Button>
      <Button type="both" @onClick="modalAddItem" class="btn-inline" text="確定" colors="main" theme="1"></Button>
    </div>
  </div>


  <h3 class="title--sub">Demo Modal使用方式</h3>
  <p class="space-out-top-base-4 space-out-bottom-base-4">show data from modal output: {{state.modalGetData}}</p>
  <Button @onClick="showModalGlobal" class="btn-inline" type="border" colors="main" text="click show modal"></Button>

  <p class="space-out-top-base-4 space-out-bottom-base-4">另一種btn</p>
  <Button @onClick="showModalGlobal2" class="btn-inline" type="border" colors="main" text="click show modal"></Button>

  <h3 class="title--sub">Link共用樣式</h3>
  <h5 class=" title--ps space-out-bottom-base-4 space-out-top-base-4">link--default</h5>
  <a href="#" class="link--default">連結示範</a>

  <h5 class=" title--ps space-out-bottom-base-4 space-out-top-base-4">link--sub</h5>
  <a href="#" class="link--sub">連結示範</a>






  <h3 class="title--sub">ContentGroup - </h3>
  <ContentGroup style="max-width: 700px;" @menuSetting="menuSetting"></ContentGroup>

  <h3 class="title--sub">Contextmenu - </h3>
  <div
    style="position: relative; width:200px; height: 20px; background-color: rgb(231, 164, 77); text-align: center; color: antiquewhite; padding: 20px 0 ;"
    @contextmenu.prevent="openContextMenu($event)">
    CLICK ME(right)
    <CTmenu @selectContextMenu="selectContextMenu" :position="state.position"></CTmenu>
  </div>





  <h3 class="title--third">Switcher - v-model:isCheck</h3>
  <p class="space-out-bottom-base-5">isCheck: {{state.isSwitcher1}}</p>
  <Switcher v-model:isCheck="state.isSwitcher1"></Switcher>
  <p class="space-out-bottom-base-5">isCheck: {{state.isSwitcher2}}</p>
  <Switcher v-model:isCheck="state.isSwitcher2"></Switcher>

  <h3 class="title--third">Slidebar - </h3>
  <Slidebar title="Brightness" :data="state.sliderdata"></Slidebar>

  <h2 class="title--sub">Modal</h2>
  <h3 class="title--third">純文字 按鈕純文字</h3>
  <div class="btn-block">
    <Button @onClick="state.isOpenNormalModal = true" class="btn-inline" type="border" colors="main"
      text="open normal popup"></Button>

    <Modal content="" v-model:isOpen="state.isOpenNormalModal" btnArrange="reverse">
      <div class="detail-block">
        <div style="height: 800px; background-color: red;"></div>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
        <p>AAA</p>
      </div>
    </Modal>
  </div>


  <h3 class="title--third">有圖檔</h3>
  <Button @onClick="state.isOpenImageModal = true" class="btn-inline" type="border" colors="main"
    text="有圖的POPUP"></Button>
  <Modal v-model:isOpen="state.isOpenImageModal" title="主標" subTitle="" alignTitle="center" alignBtn="center"
    imgLink="asus_proart_sw_ico_star_on.png" :btnConfirm="{}" :btnCancel="state.confirmBtnSetting"></Modal>

  <h2 class="title--sub">Breadcrumb</h2>
  <Breadcrumb :datas="[{text: '第一層', link:'ui'}, {text: '第9層', link:'ui'}]"></Breadcrumb>







  <h2 class="title--sub">iCon</h2>
  <p style="margin-bottom:5px">iCon : 引入svg，可以用CSS直接換顏色 </p>
  <p style="margin-bottom:10px">iconClass : delete </p>
  <iCon iconClass="delete" style=" width: 50px; height: 50px;"></iCon>
  <iCon iconClass="delete" style=" width: 50px; color: #14abb3 ;height: 50px;"></iCon>

  <h2 class="title--sub">ActionBar</h2>
  <p style="margin-bottom:30px">ActionBar data : iconList </p>
  <ActionBar></ActionBar>



  <h2 class="title--sub">CardInfo 複合式版型</h2>
  <p style="margin-bottom:30px">CardInfo data : dataInfo </p>
  <CardInfo @setCalibration="setCalibration" @setUnbind="setUnbind">
    <template #card="data">
      <div>{{data}} </div>
    </template>
  </CardInfo>

  <h2 class="title--sub">ProgressBar</h2>
  <p style="margin-bottom:30px">ProgressBar data : {{state.progress}} </p>
  <ProgressBar style="width: 400px;" :progress="state.progress"></ProgressBar>

  

  <h2 class="title--sub">TAB</h2>
  <Tab @onClick="onClickTab"></Tab>


  <h2 class="title--sub">TAB - style 2 </h2>
  <h5 class=" title--ps space-out-bottom-base-4 space-out-top-base-4">theme: 2</h5>
  <Tab @onClick="onClickTab" theme="2"></Tab>

  <h5 class=" title--ps space-out-bottom-base-4 space-out-top-base-4">wd: auto</h5>
  <Tab @onClick="onClickTab" wd="auto" theme="2"></Tab>

  <h3 class="title--third">Line Bar - </h3>
  <LineBar :data="state.LineData"></LineBar>

  <h3 class="title--third">CircleChart - </h3>
  <CircleChart :data="state.chart" total_text="Calibrated within 6 month"></CircleChart>

  <h3 class="title--third">DropDown - Text:Disband, Icon:icon-add.svg, popup_x:0, popup_y:5, data_up:array,
    data_down:array, Event:onClick</h3>
  <Dropdown id="drop1" text="Disband" :disable="true" icon="" popup_x="0" popup_y="5" :data_up=state.data_up1
    @onClick="dropdown">
  </Dropdown>
  <Dropdown id="drop2" text="" icon="asus_proart_sw_ico_download" popup_x="-100" popup_y="5" :data_up=state.data_up2
    :data_down=state.data_down2 @onClick="dropdown"></Dropdown>


  <h3 class="title--third">Cardimg - gamma:array , color:array , brightness:array , v-model:isCheck</h3>
  <p class="space-out-bottom-base-5">isCheck: {{state.cardimg_click}}</p>
  <Cardimg name="Standard Mode" icon="asus_proart_sw_ico_color" :gamma="state.gamma" :color="state.color"
    :brightness="state.brightness" v-model:isCheck="state.cardimg_click"></Cardimg>

  <h2 class="title--sub">Form - Input</h2>
  <p>input value: {{state.inputVal}}</p>
  <div class="btn-block">
    <Button :text="'isError-'+state.isInputError" @onClick="state.isInputError = !state.isInputError" type="full"
      class="btn-inline" colors="dark1" theme="2" wd="auto"></Button>
    <Button :text="'state.isInputDisable-'+state.isInputDisable" @onClick="state.isInputDisable = !state.isInputDisable"
      type="full" class="btn-inline" colors="dark1" theme="2" wd="auto"></Button>
  </div>
  <div class="input-block">
    <Input v-model:value="state.inputVal" placeholder="預設文字" :isError="state.isInputError"
      :isDisable="state.isInputDisable"></Input>
  </div>

  <h3 class="title--sub">Textarea</h3>
  <h5 class=" title--ps space-out-bottom-base-4 space-out-top-base-4">textVal: {{state.textVal}}</h5>
  <div class="btn-block space-out-bottom-base-4">
    <Button :text="'isError-'+state.isTextError" @onClick="state.isTextError = !state.isTextError" type="full"
      class="btn-inline" colors="dark1" theme="2" wd="auto"></Button>
    <Button :text="'state.isTextDisble-'+state.isTextDisble" @onClick="state.isTextDisble = !state.isTextDisble"
      type="full" class="btn-inline" colors="dark1" theme="2" wd="auto"></Button>
  </div>
  <Textarea :isError="state.isTextError" :isDisable="state.isTextDisble" v-model:value="state.textVal"></Textarea>

  <h2 class="title--sub">Form - Select</h2>
  <p>被選擇的值：{{state.selectVal}}</p>
  <div class="btn-block">
    <Button :text="'isError-'+state.isSelectError" @onClick="state.isSelectError = !state.isSelectError" type="full"
      class="btn-inline" colors="dark1" theme="2" wd="auto"></Button>
    <Button :text="'state.isSelectDisable-'+state.isSelectDisable"
      @onClick="state.isSelectDisable = !state.isSelectDisable" type="full" class="btn-inline" colors="dark1" theme="2"
      wd="auto"></Button>
  </div>
  <div class="select-block">
    <Select :options="state.op" v-model:selected="state.selectVal" style="height: 42px;"></Select>
    <Select :options="state.op" v-model:selected="state.selectVal" :isError="state.isSelectError"
      :isDisable="state.isSelectDisable"></Select>
  </div>

  <h2 class="title--sub">Form - Radio Button</h2>
  <p>selected: {{state.selectedVal}}</p>
  <Radio v-model:selected="state.selectedVal" name="001" value="val001" text="val001" ></Radio>
  <Radio v-model:selected="state.selectedVal" name="001" value="val002" text="val002" ></Radio>
  <Radio v-model:selected="state.selectedVal" name="001" value="val003" text="diable樣式demo" :isDisable="true"></Radio>
  <Radio v-model:selected="state.selectedVal" name="001" value="val003" text="diable樣式demo" :isDisable="true"></Radio>

  <h2 class="title--sub">Form - Checkbox</h2>
  <p class="space-out-bottom-base-5">isCheck: {{state.isCheck}}</p>

  <p class="space-out-bottom-sm">checkbox 兩種size 24px & 在table中的16px</p>

  <h5 class=" title--ps space-out-bottom-base-4 space-out-top-base-4">size - 16px (for table)</h5>
  <Checkbox v-model:isCheck="state.isCheck" text="測試項目" size="sm"></Checkbox>

  <h5 class=" title--ps space-out-bottom-base-4 space-out-top-base-4 ">size - 24px (for normal)</h5>
  <Checkbox v-model:isCheck="state.isCheck" text="測試項目測試項目"></Checkbox>

  <h5 class=" title--ps space-out-bottom-base-4 space-out-top-base-4 ">disable</h5>
  <Checkbox v-model:isCheck="state.isCheck" :isDisable="true" text="不能點"></Checkbox>

  <h3 class="title--third">no text</h3>
  <Checkbox v-model:isCheck="state.isCheck"></Checkbox>

  <h2 class="title--sub">Button</h2>

  <h3 class="title--third">colors: main, type: full Event: onClick</h3>
  <div class="btn-block">
    <Button class="btn-inline" @onClick="testConsole" text="按鈕1"></Button>
    <Button class="btn-inline" text="按鈕1" :disable="true"></Button>
  </div>
  <h3 class="title--third">colors: main, type: border</h3>
  <div class="btn-block">
    <Button class="btn-inline" type="border" text="按鈕1"></Button>
    <Button class="btn-inline" type="border" :disable="true" text="按鈕1"></Button>
  </div>
  <h3 class="title--third">colors: main-gradient, type: full</h3>
  <div class="btn-block">
    <Button type="full" class="btn-inline" colors="main-gradient" text="按鈕1"></Button>
    <Button type="full" class="btn-inline" colors="main-gradient" text="按鈕1" :disable="true"></Button>
  </div>
  <h3 class="title--third">colors: main2-gradient, type: full</h3>
  <div class="btn-block">
    <Button class="btn-inline" type="full" colors="main2-gradient" text="按鈕1"></Button>
    <Button class="btn-inline" type="full" colors="main2-gradient" text="按鈕1" :disable="true"></Button>
    <!-- <Button type="full" colors="main-gradient" :disable="true"></Button> -->
  </div>

  <h3 class="title--third">theme:2 , color:grey-dark, type: full, wd: sm</h3>
  <div class="btn-block">
    <Button type="full" class="btn-inline" colors="dark1" theme="2" wd="sm" text="按鈕2" icon="asus_proart_sw_ico_delete"></Button>
    <Button type="full" class="btn-inline" colors="dark1" theme="2" wd="sm" text="按鈕2" :disable="true"
      @onClick="testConsole"></Button>
  </div>

  <h3 class="title--third">有icon的按鈕　- colors: main, type: full Event: onClick icon: icon-add.svg</h3>
  <Button class="btn-inline" @onClick="testConsole" text="按鈕1" icon="icon-add"></Button>

  <h3 class="title--third">Button TEST text</h3>
  <div v-for="i in 3">
    <Checkbox v-model:isCheck="btnInfo.checkItem[i-1]" :text="'選項'+i" :value="'check'+i"></Checkbox>
  </div>
  <Checkbox v-model:isCheck="btnInfo.disable" text="btn-disable" value="disable"></Checkbox>
  <p>disable: {{btnInfo.disable}}</p>
  <Button class="btn-inline" @onClick="testConsole" :disable="btnInfo.disable"
    :text="`按鈕(${btnInfo.checkNum})`"></Button>

</div>